import React from 'react';

import uuid from 'uuid';

import { FaBullhorn, FaGasPump } from 'react-icons/fa';
import { StyledLevelReport, PainelCampaignFuel } from './style/StyledLevelReport';

const LevelReport = ({ data }) => (
	<StyledLevelReport>
		<div className="box">
			<div className="title">
				<FaBullhorn />
				<h4>{data.title}</h4>
			</div>

			{
				data.charts.map((chart) => {
					if (chart.type === 'Cards') {
						return (
							<div className="spotlight-box" key={uuid.v4()}>
								{
									chart.data.map(value => (
										<div key={uuid.v4()}>
											<h5>{value.title}</h5>
											<p>{value.value}</p>
										</div>
									))
								}
							</div>
						);
					}

					return null;
				})
			}

			<div className="content">
				<div className="mt-3">
					<h3 className="mb-3">{data.content.title}</h3>
					{/* <p dangerouslySetInnerHTML={{ __html: (data.content.text) }} /> */}
					<p>{data.content.text}</p>
				</div>

				{data.charts.map((chart) => {
					if (chart.type === 'Level') {
						const deg = (chart.data.value * 180) + 180;

						return (
							<PainelCampaignFuel rotate={`rotate(${deg}deg)`} key={uuid.v4()}>
								<div className="title">
									<FaGasPump className="icon-gas-pump" />
									<h5>{chart.title}</h5>
								</div>

								<svg className="chart" width={255} enableBackground="new 0 0 493.04 264.96" viewBox="0 0 493.04 264.96" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg">
									<path className="st0" d="m15.48 241.28c-0.31 0-0.64-0.05-0.93-0.16-3.41-1.33-3.72-4.24-3.5-7.46 1.51-21.96 4.63-43.63 11.58-64.63 4.5-13.61 10.1-26.74 16.54-39.52 2.82-5.61 3.75-5.85 9.03-2.8 18.44 10.65 36.83 21.37 55.41 31.77 4.47 2.5 5.22 4.61 2.81 9.31-10.84 21.13-17.36 43.49-17.49 67.44-0.01 1.7-0.34 3.27-1.08 4.7-0.44 0.86-1.37 1.36-2.33 1.36h-70.04z" />
									<path className="st1" d="m415.61 241.28c-0.89 0-1.6-0.73-1.6-1.62 0.15-25.42-6.51-49.21-18.07-71.7-2.18-4.23-1.24-6.19 2.47-8.3 19.07-10.86 38.1-21.79 57.07-32.83 3.32-1.94 5.19-1.07 6.77 2.02 10.11 19.77 18.07 40.31 22.93 62.04 3.49 15.59 5.28 31.35 5.74 47.27 0.05 1.71-1.34 3.13-3.06 3.13h-72.25z" />
									<path className="st2" d="m261 2.28c7.22 0.96 14.43 2.04 21.67 2.86 19.99 2.24 39.08 7.79 57.69 15.27 7.88 3.17 15.57 6.73 23.12 10.6 3.53 1.81 4.87 3.6 2.45 7.7-10.81 18.33-21.39 36.8-31.8 55.36-2.49 4.44-4.73 5.08-9.39 2.72-21.03-10.64-43.25-17.12-66.99-17.49-3.96-0.06-5.74-1.45-5.72-5.57 0.09-21.8 0.05-43.6 0.03-65.41 0-2.26 0.58-4.26 1.96-6.04h6.98z" />
									<path className="st3" d="m247 2.28c0.86 1.86 1 3.84 1 5.85-0.01 21.63-0.05 43.27 0.04 64.9 0.02 3.94-0.92 6.09-5.49 6.34-23.54 1.3-45.96 7.09-66.9 18.03-3.53 1.84-5.26 1.25-7.15-2.04-10.81-18.92-21.74-37.77-32.71-56.59-2.13-3.65-1.58-5.91 2.28-7.99 22.61-12.18 46.64-20.21 71.86-24.68 7.51-1.33 15.16-1.94 22.75-2.81 1.49-0.18 10.99-1.01 14.32-1.01z" />
									<path className="st4" d="m166.83 100.77c-0.11 2.64-1.89 3.39-3.42 4.37-16.98 10.91-31.39 24.57-43.47 40.7-2.49 3.32-4.79 6.8-7.02 10.3-1.55 2.43-3.08 2.89-5.72 1.35-19.53-11.41-39.11-22.74-58.75-33.96-4.07-2.33-2.94-4.84-1.07-7.8 14.52-22.98 32.15-43.19 53.33-60.28 7.91-6.38 16.19-12.21 24.81-17.58 2.68-1.67 4.44-1.5 6.09 1.36 11.2 19.46 22.49 38.87 33.72 58.31 0.65 1.12 1.11 2.37 1.5 3.23z" />
									<path className="st5" d="m456.45 119.47c0 2.29-1.49 3.12-2.94 3.95-19.03 10.97-38.11 21.87-57.06 32.97-3.77 2.21-5.75 1.45-8.05-2.11-12.61-19.56-28.6-35.84-48.17-48.52-5.64-3.66-5.64-3.71-2.18-9.71 10.47-18.17 20.9-36.36 31.35-54.55 3.3-5.75 3.55-5.75 9.01-2.3 25.62 16.19 47.33 36.6 65.5 60.78 4.09 5.44 7.57 11.34 11.31 17.05 0.53 0.83 0.89 1.77 1.23 2.44z" />
									<text className="st6 st7 st8" transform="translate(37.395 215.98)">E</text>
									<text className="st9 st7 st8" transform="translate(432.68 215.98)">F</text>
									<path className="seta" d="m246.12 209.28h6c8.68 1.57 17.48 2.06 26.25 2.92 32.43 3.2 64.85 6.47 97.28 9.73 1.75 0.18 4.43-0.35 4.64 1.84 0.25 2.61-2.67 2.02-4.23 2.21-11.55 1.43-23.13 2.62-34.69 3.96-30.06 3.49-60.1 7.07-90.16 10.52-6.81 0.78-12.82-2.43-15.76-8.33-2.93-5.89-2.22-11.62 1.56-16.96 2.23-3.17 5.86-4.24 9.11-5.89z" />
									<text className="st10 st7 st11" transform="translate(37.395 265)">0%</text>
									<text className="st10 st7 st11" transform="translate(432.67 265)">100%</text>
									<text className="st7 st11" transform="translate(233 265)">{`${(chart.data.value * 100).toFixed()}%`}</text>
								</svg>
							</PainelCampaignFuel>
						);
					}

					return false;
				})}

			</div>
		</div>
	</StyledLevelReport>
);

export default LevelReport;
